import * as React from 'react';

function ManageRole(props) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width={24} height={24} viewBox='0 0 24 24' {...props}>
      <g id='Group_73' data-name='Group 73' transform='translate(-654 228)'>
        <rect
          id='Rectangle_17'
          data-name='Rectangle 17'
          width={24}
          height={24}
          transform='translate(654 -228)'
          fill='#fff'
        />
        <g id='reciept' transform='translate(657 -225)'>
          <path
            id='Path_15'
            data-name='Path 15'
            d='M16.257,6.812h-2.18V1.727a.727.727,0,0,0-1.162-.581l-1.5,1.126C9.144.579,9.791.579,7.539,2.271c-2.259-1.693-1.62-1.693-3.88,0l-1.5-1.126A.727.727,0,0,0,1,1.727V14.8a2.18,2.18,0,0,0,2.18,2.18H14.8a2.18,2.18,0,0,0,2.18-2.18V7.539A.727.727,0,0,0,16.257,6.812ZM3.18,15.53a.727.727,0,0,1-.727-.727V3.18C3.906,4.248,3.477,4.226,5.6,2.635c2.252,1.693,1.613,1.693,3.872,0,2.18,1.627,1.758,1.591,3.153.545,0,12.169-.058,11.842.124,12.351ZM15.53,14.8a.727.727,0,0,1-1.453,0V8.265H15.53Z'
            fill='#003ec4'
          />
          <path
            id='Path_16'
            data-name='Path 16'
            d='M5.727,8a.727.727,0,1,0,.727.727A.727.727,0,0,0,5.727,8Z'
            transform='translate(-1.094 -1.914)'
            fill='#003ec4'
          />
          <path
            id='Path_17'
            data-name='Path 17'
            d='M12.359,8H8.727a.727.727,0,0,0,0,1.453h3.633a.727.727,0,1,0,0-1.453Z'
            transform='translate(-1.914 -1.914)'
            fill='#003ec4'
          />
          <path
            id='Path_18'
            data-name='Path 18'
            d='M5.727,12a.727.727,0,1,0,.727.727A.727.727,0,0,0,5.727,12Z'
            transform='translate(-1.094 -3.008)'
            fill='#003ec4'
          />
          <path
            id='Path_19'
            data-name='Path 19'
            d='M12.359,12H8.727a.727.727,0,0,0,0,1.453h3.633a.727.727,0,1,0,0-1.453Z'
            transform='translate(-1.914 -3.008)'
            fill='#003ec4'
          />
          <path
            id='Path_20'
            data-name='Path 20'
            d='M5.727,16a.727.727,0,1,0,.727.727A.727.727,0,0,0,5.727,16Z'
            transform='translate(-1.094 -4.102)'
            fill='#003ec4'
          />
          <path
            id='Path_21'
            data-name='Path 21'
            d='M12.359,16H8.727a.727.727,0,0,0,0,1.453h3.633a.727.727,0,1,0,0-1.453Z'
            transform='translate(-1.914 -4.102)'
            fill='#003ec4'
          />
        </g>
      </g>
    </svg>
  );
}
export default ManageRole;
